import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ButtonModule, TooltipModule } from '@eg/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { CustomerRemarkModel } from '@railmybox/api-user';
import { SharedPipesModule } from '@railmybox/shared/pipes';
import { CardModule } from 'primeng/card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'rmb-notification-item',
  imports: [CommonModule, CardModule, ButtonModule, TooltipModule, TranslocoModule, SharedPipesModule, RouterLink],
  templateUrl: './notification-item.component.html',
  styleUrl: './notification-item.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class NotificationItemComponent implements AfterViewInit {
  readonly TRANSLOCO_PREFIX = 'notification-center';
  @Input() notification: CustomerRemarkModel;
  @Output() taskHandler = new EventEmitter<CustomerRemarkModel>();
  @Output() readHandler = new EventEmitter<CustomerRemarkModel>();
  @Output() clickNotification = new EventEmitter<PointerEvent>();

  @ViewChild('contentNotification') content!: ElementRef<HTMLDivElement>;

  isOverflowing = false;
  expanded = false;

  ngAfterViewInit() {
    queueMicrotask(() => {
      const el = this.content.nativeElement;
      this.isOverflowing = el.scrollHeight > el.clientHeight;
    });
  }

  handleTask() {
    this.taskHandler.emit(this.notification);
  }

  handleRead() {
    this.readHandler.emit(this.notification);
  }
}
